import React from 'react';
import { Box, Alert } from '@mui/material';
import { utils } from '../../services/wordpressApi';

interface YouTubeEmbedProps {
  videoUrl: string;
  title?: string;
  maxWidth?: number | string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ 
  videoUrl, 
  title = 'Video', 
  maxWidth = '100%' 
}) => {
  const youtubeData = utils.extractYouTubeData(videoUrl);

  if (!youtubeData || !youtubeData.videoId) {
    return (
      <Alert severity="warning" sx={{ bgcolor: 'rgba(255, 193, 7, 0.1)', color: 'warning.main' }}>
        Invalid YouTube URL provided
      </Alert>
    );
  }

  const { videoId, startTime } = youtubeData;
  const embedUrl = `https://www.youtube.com/embed/${videoId}${startTime ? `?start=${startTime}` : ''}`;

  return (
    <Box sx={{ maxWidth, mx: 'auto' }}>
      <Box
        sx={{
          position: 'relative',
          paddingBottom: '56.25%', // 16:9 aspect ratio
          height: 0,
          overflow: 'hidden',
          borderRadius: 2,
          bgcolor: 'rgba(255, 255, 255, 0.04)',
          border: '1px solid rgba(255, 255, 255, 0.08)',
        }}
      >
        <Box
          component="iframe"
          src={embedUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none',
            borderRadius: 2,
          }}
        />
      </Box>
    </Box>
  );
};

export default YouTubeEmbed; 